<i
  class="pi pi-stopwatch mx-3 my-3 text-xl cursor-pointer p-text-secondary"
  (click)="op.toggle($event)"
  pTooltip="Просроченные"
  tooltipPosition="top"
  tooltipStyleClass="p-n-tooltip"
  [showDelay]="200"
  [life]="1000">
</i>

<p-overlayPanel
  #op
  [style]="{ width: '400px' }"
  styleClass="dropdown-overlay-panel informer-overlay-panel"
  (onShow)="loadNotifications()">
  <ng-template pTemplate="">
    <div
      class="flex justify-content-between py-2 text-white border-round-top-md"
      style="background: #23538c">
      <div class="flex align-items-center">
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          class="p-button-rounded text-white p-button-text mx-1"
          (click)="loadNotifications()"></button>
        <p class="font-bold">Просроченные</p>
      </div>
    </div>

    <ng-container *ngIf="loading; else notificationsTemplate">
      <crm-spinner top="mt-3"></crm-spinner>
    </ng-container>
    <ng-template #notificationsTemplate>
      <div
        class="overflow-y-auto"
        style="height: 400px">
        <div *ngFor="let expired of expiredTasksByType">
          <div
            *ngIf="expired.tasks?.length"
            class="flex h-3rem px-3 py-2 align-items-center text-gray-500 font-bold border-top-1 border-bottom-1 border-gray-200">
            {{ expired.title }}
          </div>
          <div
            *ngFor="let task of expired.tasks"
            class="flex px-3 py-2 gap-2 justify-content-between align-items-center">
            <a
              [routerLink]="getEntityTypeLink(task)"
              (click)="op.hide()">
              {{ task.name }}
            </a>
            <crm-status-label
              [name]="task.status.name"
              [color]="task.status.color"></crm-status-label>
          </div>
        </div>
        <div
          *ngIf="paginationLoading"
          class="text-center">
          <p-progressSpinner
            [style]="{
              width: '50px',
              height: '50px'
            }"></p-progressSpinner>
        </div>

        <div *ngIf="!countItems">
          <crm-no-data [size]="NoDataSize"></crm-no-data>
          <h4 class="font-normal text-center">Нет просроченных</h4>
        </div>
      </div>
    </ng-template>
  </ng-template>
</p-overlayPanel>
